export const LAYOUT_LOADING_SIDENAV = "LAYOUT_LOADING_SIDENAV";
export const LAYOUT_LOADING_CONTENT = "LAYOUT_LOADING_CONTENT";
export const LAYOUT_PROPS_DYNAMIC = "LAYOUT_PROPS_DYNAMIC";
